import React, {useMemo} from "react";
import {Title} from "./Title";

const EmptyProductList = ({label, removeAllFiltersActive, isNoResult, isSearch, keyWord}) => {
    const memoizedTitleChildren = useMemo(() =>
            !isSearch && !isNoResult ?
                <h1 className='dp__header__title'>{label}</h1> :
                isSearch && !isNoResult && keyWord ?
                    <h2 className='dp__header__title'>Aucun résultat ne correspond à "{keyWord}"</h2> :
                    <h2 className='dp__header__title'>Résultats pour "{keyWord}"</h2>
        , [isSearch, isNoResult, keyWord]);

    return (
        <div className="dp" id="conteneur_central">
            <section>
                <Title>
                    {memoizedTitleChildren}
                </Title>
            </section>
            <div className="dp__content">
                <div className="dp__content-empty">
                    <strong>Désolé, nous n'avons pas trouvé de résultats liés à votre recherche...</strong>
                    <span>Réinitialisez les filtres pour voir davantage de résultats</span>
                    <a href="#" onClick={removeAllFiltersActive} title="Réinitialisez les filtres">Réinitialisez les
                        filtres</a>
                </div>
                <div className="target2sell" id='PPNA1QL127P68J-1405-135'/>
            </div>
        </div>
    )
}
export default EmptyProductList;